export interface Language {
  code: string;
  name: string;
  flag?: string;
}

export const LANGUAGES: Language[] = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "ja", name: "日本語", flag: "🇯🇵" },
  { code: "zh", name: "中文", flag: "🇨🇳" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "hi", name: "हिन्दी", flag: "🇮🇳" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "ko", name: "한국어", flag: "🇰🇷" },
  { code: "pt", name: "Português", flag: "🇵🇹" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "id", name: "Bahasa Indonesia", flag: "🇮🇩" },
  { code: "nl", name: "Nederlands", flag: "🇳🇱" },
  { code: "tr", name: "Türkçe", flag: "🇹🇷" },
  { code: "fil", name: "Filipino", flag: "🇵🇭" },
  { code: "pl", name: "Polski", flag: "🇵🇱" },
  { code: "sv", name: "Svenska", flag: "🇸🇪" },
  { code: "bg", name: "Български", flag: "🇧🇬" },
  { code: "ro", name: "Română", flag: "🇷🇴" },
  { code: "ar", name: "العربية", flag: "🇸🇦" },
  { code: "cs", name: "Čeština", flag: "🇨🇿" },
  { code: "el", name: "Ελληνικά", flag: "🇬🇷" },
  { code: "fi", name: "Suomi", flag: "🇫🇮" },
  { code: "hr", name: "Hrvatski", flag: "🇭🇷" },
  { code: "ms", name: "Bahasa Melayu", flag: "🇲🇾" },
  { code: "sk", name: "Slovenčina", flag: "🇸🇰" },
  { code: "da", name: "Dansk", flag: "🇩🇰" },
  { code: "ta", name: "தமிழ்", flag: "🇮🇳" },
  { code: "uk", name: "Українська", flag: "🇺🇦" },
  { code: "ru", name: "Русский", flag: "🇷🇺" },
];

export interface List {
  id: string;
  name: string;
}
export interface LLMModel extends List {
  provider: "OpenAI" | "Anthropic" | "Google" | "xAI" | "Alibaba" | "ElevenLabs";
}

export interface Tool {
  id: string;
  name: string;
  description: string;
}

// ElevenLabs client tool that lets the AI trigger a live voice handoff
// (src/services/integrations/elevenlabs/VoiceAgentService.ts's requestHumanHandoff
// clientTools entry). Not listed in ToolList: the server attaches it exactly
// while Live Handoff from Browser is on and the genie has no transfer numbers
// (handle-agent's syncHumanHandoffTool).
export const REQUEST_HUMAN_HANDOFF_TOOL_ID = "tool_1201kzrpdbnveg983kbb76wye35v";

// ElevenLabs system tool behind transfer numbers, and the only person tool a
// genie with transfer numbers carries. It transfers phone calls; in a website
// chat VoiceAgentService turns an attempt into the browser handoff.
export const PHONE_TRANSFER_TOOL_NAME = "transfer_to_number";

// ElevenLabs client tool that shows the visitor a relevant link and/or image in
// the chat (VoiceAgentService's showRelatedMedia clientTools entry — the agent
// only passes a topic; the resolve-media action picks what to show). Attached
// to new genies by default (supabase/functions/handle-agent/utils/client-tools.ts,
// keep the id in sync).
export const SHOW_RELATED_MEDIA_TOOL_ID = "tool_8901m3sp429deynv7vsyjmpqfzzd";
export const SHOW_RELATED_MEDIA_TOOL_NAME = "showRelatedMedia";

// ElevenLabs client tool that shows the visitor the contact form when they show
// buying intent (VoiceAgentService's requestContactDetails clientTools entry).
// Not listed in ToolList: the server attaches it exactly while "Count chat
// leads as ad conversions" is on (handle-agent's syncContactDetailsTool, keep
// the id in sync).
export const REQUEST_CONTACT_DETAILS_TOOL_ID = "tool_0001m6karakefaxrv2p1ngqrwsz3";
export const REQUEST_CONTACT_DETAILS_TOOL_NAME = "requestContactDetails";

export const ToolList: Tool[] = [
  {
    id: SHOW_RELATED_MEDIA_TOOL_ID,
    name: "Show Links & Images",
    description: "Shows visitors a relevant link or picture in the chat while the genie talks about it",
  },
  {
    id: "tool_8001kp90dpmmfzdbpkr30gsdr06s",
    name: "Private Context Search",
    description: "Searches your configured private data source for business-specific information",
  },
  {
    id: "tool_2201kbdmxqtge8sbmmp5akn9p5wq",
    name: "Dynamic Variable Resolver",
    description: "Retrieves all dynamic variables defined on the agent and resolves their values",
  },
  {
    id: "tool_4801k6a6sqj3fwttv31g51bh8ss3",
    name: "Web Search",
    description: "Searches the web and summarizes the results into a short answer",
  },
  // {
  //   id: "tool_5901k83hcxtwftptz3ayd146veta",
  //   name: "Quick Search",
  //   description: "Performs quick research using web search and summarizes the findings",
  // },
  // {
  //   id: "tool_8701k83hnm7xf56vw15y024vhwvz",
  //   name: "Deep Search",
  //   description: "Performs an in-depth search on the web to find detailed information",
  // },
];

export interface Voice extends List {
  description?: string;
  preview_url?: string;
}

